import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginScreen from './components/LoginScreen';
import Header from './components/Header';
import VideoUpload from './components/VideoUpload';
import VideoList from './components/VideoList';
import { VideoMetadata } from './services/azureBlobService';
import './App.css';

const AppContent: React.FC = () => {
  const { user, isLoading } = useAuth();
  const [currentPage, setCurrentPage] = useState<'upload' | 'list'>('list');

  const handleUploadComplete = (video: VideoMetadata) => {
    // Switch to list view after successful upload
    setCurrentPage('list');
  };

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <LoginScreen />;
  }

  return (
    <div className="app">
      <Header currentPage={currentPage} onPageChange={setCurrentPage} />
      
      <main className="app-main">
        {currentPage === 'upload' && (
          <VideoUpload onUploadComplete={handleUploadComplete} />
        )}
        {currentPage === 'list' && <VideoList />}
      </main>

      <footer className="app-footer">
        <p>&copy; 2025 Video Upload App. Built with React, Azure Blob Storage, and Google Auth.</p>
      </footer>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
